import { InstallWrapper } from "@/components/InstallWrapper";
import { Button } from "@/components/ui/button";
import React from "react";

export const InstallButton: React.FC = () => {
  return (
    <InstallWrapper>
      <Button
        aria-label="Installer cette application"
        size="lg"
        className="h-12 w-full"
      >
        Commencer l'aventure
      </Button>
    </InstallWrapper>
  );
};
